import React from 'react';

const TwoDimensionalImageContext = React.createContext({
});

export default TwoDimensionalImageContext;
